import { Buildings, Users } from "@phosphor-icons/react"
import { createFileRoute, Outlet, useMatchRoute, useNavigate } from "@tanstack/react-router"
import UserActionsDropdown from "~/components/customer-management/UserActionsDropdown"
import { Module } from "~/components/design-system/pages"
import { Badge } from "~/components/reusable/Badge"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { type HeaderTab } from "~/components/reusable/HeaderTabs"
import CreateOrganizationDialog from "~/components/reusable/organizations/CreateOrganizationDialog"
import NotifyCustomerDialog from "~/components/status/components/NotifyCustomerDialog"
import { type Organization } from "~/server/api/routers/auth0"
import { isProduction } from "~/utils/environment"

export const Route = createFileRoute("/_auth/internal/customer-management/_layout")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

const tabs: HeaderTab[] = [
  {
    label: "Organizations",
    path: "/internal/customer-management/organizations",
    icon: <Buildings />,
  },
  {
    label: "Users",
    path: "/internal/customer-management/users",
    icon: <Users />,
  },
]

function RouteComponent() {
  const matchRoute = useMatchRoute()
  const navigate = useNavigate()
  const onOrganizations = matchRoute({ to: "/internal/customer-management/organizations" })

  const handleOrganizationCreated = (organization: Organization) => {
    void navigate({
      to: "/internal/customer-management/organizations",
      search: { org: organization.id },
    })
  }

  return (
    <Module
      breadcrumb={<BreadcrumbWrapper />}
      actions={
        onOrganizations ? (
          <>
            <NotifyCustomerDialog />
            <CreateOrganizationDialog onOrganizationCreated={handleOrganizationCreated} />
          </>
        ) : (
          <>
            {!isProduction() && (
              <Badge variant="red" className="animate-pulse">
                Changes affects production users
              </Badge>
            )}
            <UserActionsDropdown />
          </>
        )
      }
      tabs={{ items: tabs, path: "/internal/customer-management" }}
    >
      <Outlet />
    </Module>
  )
}
